export default "__VITE_ASSET__CXN2oA9F__"